<template>
    <md-menu md-direction="bottom-start" md-align-trigger>
        <md-button md-menu-trigger><i class="material-icons">menu</i></md-button>

        <md-menu-content>
            <md-menu-item v-for="item of items" :key="item.id" :href="item.url">{{ item.label }}</md-menu-item>
        </md-menu-content>
    </md-menu>
</template>

<script>
    export default {
        props: {
            items: Array,
            privateUrl: String,
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/MobileMainMenuComponent.vue